// Header.tsx
import { Box, Flex, Text, Link, Spacer } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";

const Header: React.FC = () => {
    const adminURL = process.env.REACT_APP_BACKEND_APP_URL + "/admin/";
    return (
        <Flex bg="brand.900" p={4} color="white">
            <Box p="2">
                <Text fontSize="xl">CSツール管理画面</Text>
            </Box>
            <Spacer />
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                mr={2}
            >
                <Link as={RouterLink} to="/dashboard" mx={4}>
                    ホーム
                </Link>
                <Link href={adminURL} isExternal mx={4}>
                    管理画面
                </Link>
            </Box>
        </Flex>
    );
};

export default Header;
